import * as React from 'react';

/**
 * Optical vertical centering wrapper. Wraps a TEXT label so `text-box-trim`
 * (defined in landing.css behind `@supports (text-box-trim)`) can trim the
 * label to its cap-height box and center it by visible ink rather than by the
 * font's line box. `text-box-trim` does not apply to the flex button/link
 * containers themselves, so the label needs this inline-block wrapper.
 *
 * Icons (e.g. <ArrowIcon/>) must stay OUTSIDE this wrapper as siblings so the
 * trim sees a text-only inline-block. On engines without text-box-trim support
 * (Firefox) the wrapper is inert and the halved padding-nudge fallback in
 * landing.css keeps the label centered.
 */
export function Cap({ children }: { children: React.ReactNode }) {
  return <span className="cultiv-tb">{children}</span>;
}
